
import { Union, Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type, obj_type, record_type, option_type, bool_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { toArray, some } from "../fable_modules/fable-library-js.5.3.0/Option.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { awaitPromise, startAsPromise } from "../fable_modules/fable-library-js.5.3.0/Async.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.5.3.0/AsyncBuilder.js";

/**
 * Browsers drop the lock when the page is hidden; re-request only once it is visible again.
 */
export function shouldReacquire(visibilityState) {
    return visibilityState === "visible";
}

/**
 * Whether the view is open and which lock sentinel (if any) is currently held for it.
 */
export class WakeLockHold$1 extends Record {
    constructor(IsOpen, Held) {
        super();
        this.IsOpen = IsOpen;
        this.Held = Held;
    }
}

export function WakeLockHold$1_$reflection(gen0) {
    return record_type("Shared.ScreenWakeLock.WakeLockHold`1", [gen0], WakeLockHold$1, () => [["IsOpen", bool_type], ["Held", option_type(gen0)]]);
}

export function openHold() {
    return new WakeLockHold$1(true, undefined);
}

/**
 * A lock arrived: held while open (replacing, and so releasing, any earlier one); released at once after close.
 */
export function lockArrived(sentinel, hold) {
    if (hold.IsOpen) {
        return [new WakeLockHold$1(hold.IsOpen, some(sentinel)), ofArray(toArray(hold.Held))];
    }
    else {
        return [hold, singleton(sentinel)];
    }
}

/**
 * The view closed or unmounted: nothing stays held and any held lock is released.
 */
export function close(hold) {
    return [new WakeLockHold$1(false, undefined), ofArray(toArray(hold.Held))];
}

/**
 * A new lock is wanted only while open and the page is visible.
 */
export function wantsReacquire(hold, visibilityState) {
    if (hold.IsOpen) {
        return shouldReacquire(visibilityState);
    }
    else {
        return false;
    }
}

export class AcquireOutcome extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Acquired", "Unsupported", "Rejected"];
    }
}

export function AcquireOutcome_$reflection() {
    return union_type("Shared.ScreenWakeLock.AcquireOutcome", [], AcquireOutcome, () => [[["sentinel", obj_type]], [], []]);
}

/**
 * navigator.wakeLock.request bound to navigator.wakeLock, or None when absent. Read at call time only.
 */
export function browserRequest() {
    return typeof navigator !== 'undefined' && navigator.wakeLock && typeof navigator.wakeLock.request === 'function' ? navigator.wakeLock.request.bind(navigator.wakeLock) : undefined;
}

/**
 * Requests a 'screen' lock; any rejection (NotAllowedError, low battery, hidden page) is Rejected.
 */
export function tryAcquire(request) {
    if (request != null) {
        const request_1 = request;
        return startAsPromise(singleton_1.Delay(() => singleton_1.TryWith(singleton_1.Delay(() => singleton_1.Bind(awaitPromise(request_1("screen")), (_arg) => singleton_1.Return(new AcquireOutcome(0, [_arg])))), (_arg_1) => singleton_1.Return(new AcquireOutcome(2, [])))));
    }
    else {
        return startAsPromise(singleton_1.Delay(() => singleton_1.Return(new AcquireOutcome(1, []))));
    }
}

/**
 * Releases a held sentinel; a failed release is ignored (the browser may already have released it).
 */
export function release(sentinel) {
    let pr;
    (pr = (sentinel.release()), pr.catch((value) => {
    }));
}

export function currentVisibilityState() {
    return document.visibilityState;
}

//# sourceMappingURL=ScreenWakeLock.js.map
